import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as Enums from '../../../../Autofacets-Core/src/app/utils/enums';
import { AdditionalWorkDemandList, AppointmentDemandList } from '../business-entities/appointment-demand-list-view-model';
import { AdditionalWorkJobList, AppointmentJobList, AppointmentPriceDetails } from '../business-entities/appointment-Job-list-view-model';
import { AdditionalWorkJobDetailsList, AppointmentJobDetailList } from '../business-entities/appointment-JobDetail-list-view-model';
import { TaxDetail } from '../business-entities/appointment-service-details-view-model';
import { AppointmentDetail } from '../business-entities/appointmentDetail-model';
import { RentalCar } from '../business-entities/appointmentList-model';
import { PartDetailsViewModel } from '../business-entities/part-details-view-model';
import { Features } from '../business-entities/user-role-view-model';
import { EditAppointmentService } from './edit-appointment.service';
import { PartsBusinessService } from './parts.service';
import { PartNumberModel } from '../business-entities/parts-list-view-model';

@Injectable({ providedIn: 'root' })
export class AppointmentWorkOrderService {
  appointmentDemandList: Array<AppointmentDemandList>;
  appointmentJobList: Array<AppointmentJobList>;
  appointmentJobDetailList: Array<AppointmentJobDetailList>;
  appointmentPriceDetails: Array<AppointmentPriceDetails>;
  additionalDemandList: Array<AdditionalWorkDemandList>;
  additionalJobList: Array<AdditionalWorkJobList>;
  additionalJobDetailsList: Array<AdditionalWorkJobDetailsList>;
  taxDetail: TaxDetail;
  contactDetails: AppointmentDetail;
  totalPriceToDisplay:number;
  totalPrice: number;
  totalTime: number;
  rentalCompanyMakeName:string;
  priceForDisply:string;
  totalInvoicePrice: number;
  appointmentJobDetailToUpdate: Array<AppointmentJobDetailList> = [];
  qtyCheck: boolean = false;
  demandQtyCheckflag = true;
  isUpdateAppointment: boolean = false;
  isDiscountError: boolean = false;
  // Guards against overlapping UpdateAppointment calls for the same appointment, fired from
  // any of: the Save button, WorkOrderServicesComponent's auto-save on Add/Delete Service,
  // and the Additional Work tab. Scoped per-appointmentId, not a single global flag, so a
  // save on one work order can never block a save on a different one.
  private savingAppointmentIds = new Set<number>();
  isSavingAppointment(appointmentId: number): boolean {
    return this.savingAppointmentIds.has(appointmentId);
  }
  beginSave(appointmentId: number): void {
    this.savingAppointmentIds.add(appointmentId);
  }
  endSave(appointmentId: number): void {
    this.savingAppointmentIds.delete(appointmentId);
  }
  partList: PartDetailsViewModel[] = [];
  personnelTax: number = 0;
  materialTax: number = 0;
  totalPriceInclVAT: number = 0;
  overAllAmountInclTAX:number=0;
  isRentalCarUpdated: boolean = false;
  selectedRentalCarDetail: RentalCar;
  isDisableSaveButton: boolean = false;
  features: Features[] = [];
  BookingDatetime: Date = null;
  isJobDetailDiscountError:boolean=false
  isAdditionalJobDetailDiscountError:boolean=false
  isWarrantyDocumentSigned: boolean=false;
  isAnyWarrantyDemandExists: boolean=false;
  isWarrantyDocumentGenerated: boolean=false;
  importedCar?:boolean = false;
  toweinCars?:boolean = false;
  constructor(
    private editAppointmentService: EditAppointmentService,
    private globalSetting: GlobalSetting,
    private cookieservice: CookieService,
    private partService: PartsBusinessService,
    private secureStorage: SecureStorage
  ) { }

  MapToViewModel(isUpdateAppointment: boolean, isDelete: boolean): any {
    let jobDetailViewModel = [];
    let jobViewModel = [];
    let demandViewModel = [];
    jobDetailViewModel = this.mapUpdateJobDetailViewModel(this.appointmentJobDetailToUpdate);
    jobViewModel = this.mapUpdateJobViewModel(this.appointmentJobList);
    demandViewModel = this.mapUpdateDemandViewModel(this.appointmentDemandList, isDelete);
    const model: any = {
      Id: this.editAppointmentService.appointmentDetails.id,
      AppointmentStatusId: this.editAppointmentService.appointmentDetails.appointmentStatusId,
      Address: this.contactDetails.address,
      Email: this.contactDetails.email,
      Mobile: this.contactDetails.mobileNo,
      CustomerMobileCode: this.contactDetails.customerMobileCode,
      Postcode: this.contactDetails.postCode,
      City: this.contactDetails.city,
      UserId: '',
      IsGeneralDetailsModified: true,
      // WorkOrderStatusId: this.editAppointmentService.appointmentDetails.workOrderStatusId,
      WorkOrderStatusId: this.editAppointmentService.appointmentDetails.workOrderStatusId,
      AppointmentJobDetailsList: jobDetailViewModel,
      AppointmentJobList: jobViewModel,
      AppointmentDemandList: demandViewModel,
      ContactInfo: this.contactDetails.contactInfo,
      SinglePhoneNo: this.contactDetails.singlePhoneNo,
      NomineeMobileCode: this.contactDetails.nomineeMobileCode,
      AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid,
      CustomerDiscount: this.contactDetails.discount,
      LanguageCode: this.cookieservice.get('userSelectedLanguage'),
      Kilometer: this.contactDetails.kilometer?.toString() !== '' ? this.contactDetails.kilometer : 0,
      IsPickUpDropOffService: this.contactDetails.isPickUpDropOffService,
      PickUpDateTime: this.contactDetails.pickUpDateTime ? this.contactDetails.pickUpDateTime : null,
      DropOffDateTime: this.contactDetails.dropOffDateTime ? this.contactDetails.dropOffDateTime : null,
      IsCustomerWaiting: this.contactDetails.isCustomerWaiting,
      IsKeyDrop: this.contactDetails.isKeyDrop,
      IsAutoKey: this.contactDetails.isAutoKey,
      AvailCheckInFacility: this.contactDetails.isCheckIn,
      FinishedTime: this.contactDetails.finishedTime ? this.contactDetails.finishedTime : null,
      DeliveryTime: this.contactDetails.deliveryTime ? this.contactDetails.deliveryTime : null,
      IsRentalCarRequire: this.contactDetails.isRentalCarSelected ? this.contactDetails.isRentalCarSelected : false,
      IsRentalCarUpdated: this.isRentalCarUpdated,
      IsNeedAttention : this.contactDetails.needAttention == null? 0 : this.contactDetails.needAttention,
      RentalCar: this.contactDetails.isRentalCarSelected || this.isRentalCarUpdated ? this.selectedRentalCarDetail : null,
      IsFromSSM: this.editAppointmentService.isExported,
      ExportedJson: this.editAppointmentService.isExported ? this.editAppointmentService.exportedJson : null,
      IntegrationWithDMS: false,
      ModuleId: 0,
      BillToEmail: this.contactDetails.billToEmail,
      BillToMobile: this.contactDetails.billToMobile,
      BillToCustomerMobileCode: this.contactDetails.billToCustomerMobileCode,
      BookingDateTime: this.BookingDatetime,
      IsGenericRentalCar: this.contactDetails.isGenericRentalCarSelected,
      GenericRentalCarTypeId: this.contactDetails.isGenericRentalCarSelected ? this.contactDetails.genericRentalCarTypeId : 0,
      IsDeletedAction: isDelete,
      realtimeDmsSyncAppointment: true,
      AppointmentType: this.editAppointmentService.appointmentDetails.appointmentType,
      DocumentPartStatus : this.editAppointmentService.appointmentDetails.documentPartStatus,
      DocumentPartStatusId: this.editAppointmentService.appointmentDetails.documentPartStatusId,
      DealerId: this.editAppointmentService.appointmentDetails.dealerId,
      DealerName: this.editAppointmentService.appointmentDetails.dealerName,
      LicensePlate: this.editAppointmentService.appointmentDetails.licensePlate,
      CustomerName: this.editAppointmentService.appointmentDetails.customerName,
      WorkOrderNo: this.editAppointmentService.appointmentDetails.workOrderNo,
      BillToCustomerNo: this.contactDetails.billtoCustomerNo,
      PaymentMethodCode: this.contactDetails.paymentMethodCode,
      PaymentTermCode: this.contactDetails.paymentTermsCode,
      DMSPOGuid:this.contactDetails.dmspoGuid,
      Information:this.contactDetails.information,
      MakeCode:this.editAppointmentService.appointmentDetails.brandCode,
      ParkingNote:this.contactDetails.parkingNote,
      ImportedCar:this.contactDetails.importedCar,
      ToweinCars: this.contactDetails.toweinCars,
      CampaignService:this.contactDetails.campaignService,
      InvoiceReference:this.contactDetails.invoiceReference,
      IsNeedTransportTicket:this.editAppointmentService.appointmentDetails.needTransportTicket,
      IsNoNeedTransport:this.editAppointmentService.appointmentDetails.noNeedTransport,
      IsFromMpo: this.editAppointmentService.isMPOEnabled,
      ExportedMpoData: this.editAppointmentService.isMPOEnabled ? this.editAppointmentService.exportedMpoData : null,
      CampaignServiceText:this.contactDetails.campaignServiceText,
      CampaignServiceId:this.contactDetails.campaignServiceId,
      DiscountCode:this.contactDetails.discountCode,
      IsTireHotel:this.contactDetails.isTireHotel,
      serviceAdvisorId:this.contactDetails.serviceAdvisorId,
      isAuthorizedByServiceAdvisor:this.contactDetails.isAuthorizedByServiceAdvisor,
      appointmentChangeVersion:this.contactDetails.appointmentChangeVersion
    };
    model.ModuleId = Enums.ModuleNames.Appointment;
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features?.length > 0 && isUpdateAppointment) {
      model.IntegrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      model.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
    }
    return model;
  }
  mapUpdateJobDetailViewModel(jobDetailUpdate: Array<AppointmentJobDetailList>): any {
    let supperArray = [];
    if (jobDetailUpdate && jobDetailUpdate.length > 0) {
      jobDetailUpdate.forEach(element => {
        let single = Object();
        single.Id = element.id;
        single.AppointmentDemandId = 0;
        single.AppointmentJobId = element.appointmentJobId;
        single.ServiceId = element.serviceId;
        single.CostType = element.costType;
        single.Description = element.description;
        single.FixedPrice = element.fixedPrice !== null ? this.globalSetting.getFormattedprice(element.fixedPrice.toString()) : element.fixedPrice
        single.IsDeleted = element.isDeleted ? element.isDeleted : false;
        single.JobId = element.jobId;
        single.DemandNo = element.demandNo;
        if (this.isUpdateAppointment) {
          if (element.plannedQuantity.toString().toLowerCase().endsWith(',')) { element.plannedQuantity = +element.plannedQuantity.toString().slice(0, -1); }
          element.plannedQuantity = parseFloat(element.plannedQuantity.toString().replace(/,/g, '.')); //Outputs: Tabs1
          element.plannedQuantity = +element.plannedQuantity;
          single.Quantity = +element.plannedQuantity === 0 ? +element.quantity : +element.plannedQuantity;
          single.SalesPriceAmount = +element.plannedQuantity === 0 ? +element.quantity * +element.unitPrice : +element.plannedQuantity * +element.unitPrice;
          single.SalesPriceAmount = single.SalesPriceAmount.toFixed(2);
          if (isNaN(single.SalesPriceAmount) || single.SalesPriceAmount == null){single.SalesPriceAmount = 0}
        }
        else {
          if(element.id == 0)
          {
	          single.Quantity = element.quantity
          }
          else
          {
	          if(element.plannedQuantity)
	          {
		          single.Quantity =element.plannedQuantity
	          }
	        else
	        {
		        single.Quantity =0
	          }
          }
          single.SalesPriceAmount = (element.id == 0 && element.costType == "Personnel") || element.plannedQuantity ? +element.unitPrice * +single.Quantity : +element.salesPriceAmount * single.Quantity;
          single.SalesPriceAmount = single.SalesPriceAmount.toFixed(2);
          if (isNaN(single.SalesPriceAmount) || single.SalesPriceAmount == null){single.SalesPriceAmount = 0}
        }
        single.PartNumber = element.salesPart;
        single.unitPrice = element.unitPrice;
        single.dmsLineNo = element.dmsLineNo;
        single.bomTypeId = element.bomTypeId;
        single.partTotalQtyOnLocal =  element.partTotalQtyOnLocal ?? 0;
        single.partAvailableQtyOnCentral =  element.partAvailableQtyOnCentral ?? 0;
        single.partAvailableQtyOnHand =  element.partAvailableQtyOnHand ?? 0;
        single.discount=element.discount  ? this.globalSetting.getFormattedprice(element.discount.toString()) : element.discount
        single.packageNo=element.packageNo  ? element.packageNo : null;
        single.packageVersionNo=(element.packageVersionNo !== 0 || element.packageVersionNo !==null )? element.packageVersionNo : 0;
        single.billToCustomer = this.appointmentDemandList.length > 0 ? this.appointmentDemandList.find(f=>f.demandNo == element.demandNo)?.billToCustomer : "";
        single.billToCustomerName = this.appointmentDemandList.length > 0 ? this.appointmentDemandList.find(f=>f.demandNo == element.demandNo)?.billToCustomerName : "";
        single.MakeCode = element.makeCode;
        single.selectedWarningLightId=element.selectedWarningLightId;
        single.packageVersionName = element.packageVersionName;
        single.dmspoLineGuid = element.dmspoLineGuid;
        single.afxPackageNo = element.afxPackageNo  ? element.afxPackageNo : null;
        single.afxPackageVersionNo = (element.afxPackageVersionNo !== 0 || element.afxPackageVersionNo !==null )? element.afxPackageVersionNo : 0;
        single.costPrice = element.costPrice;
        single.itemGroupCode = element.itemGroupCode;
        single.isAdditionalWork = !this.empty(element.isAdditionalWork)?element.isAdditionalWork : false;
        single.lastDirectCost = element.lastDirectCost;
        single.listPriceLCY = element.listPriceLCY;
        single.isToSkipTaxCalculation = element.isToSkipTaxCalculation;
        single.itemStatusId =  element.itemStatusId ?? 0;
        supperArray.push(single);
      })

    }
    return supperArray;
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  mapUpdateJobViewModel(jobUpdate: Array<AppointmentJobList>): any {
    let supperArray = [];
    if (jobUpdate && jobUpdate.length > 0) {
      jobUpdate.forEach(element => {
        let single = Object();
        single.Id = element.id;
        single.AppointmentDemandId = element.appointmentDemandId;
        single.Description = element.description;
        single.comment = "";
        single.IsDeleted = element.isDeleted;
        single.JobId = element.jobId;
        single.DemandNo = element.demandNo;
        single.FixedPrice = element.fixedPrice !== null ? this.globalSetting.getFormattedprice(element.fixedPrice.toString()) : element.fixedPrice;
        single.packageNo = element.packageNo;
        single.packageVersionNo = element.packageVersionNo;
        single.packageMakeCode = element.packageMakeCode;
        single.packageVersionName = element.packageVersionName;
        single.afxPackageNo = element.afxPackageNo  ? element.afxPackageNo : null;
        single.afxPackageVersionNo = (element.afxPackageVersionNo !== 0 || element.afxPackageVersionNo !==null )? element.afxPackageVersionNo : 0;
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  mapUpdateDemandViewModel(jobDetailUpdate: Array<AppointmentDemandList>, isDelete: boolean): any {
    let supperArray = [];
    if (jobDetailUpdate && jobDetailUpdate.length > 0) {
      jobDetailUpdate.forEach(element=>{
        if (!isDelete && element.shortDescription == "") {
          return 0;
        }
        let single = Object();
        single.Id = element.id;
        single.ShortDescription = element.shortDescription;
        single.CustomerRequirement = element.customerRequirement;
        single.FixedPrice = element.fixedPrice !== null ? this.globalSetting.getFormattedprice(element.fixedPrice.toString()) : element.fixedPrice
        single.IsDeleted = element.isDeleted ? element.isDeleted : false;
        single.AppointmentId = this.editAppointmentService.appointmentDetails.id;
        single.DemandNo = element.demandNo;
        single.IsInWarranty = element.isInWarranty;
        single.SentForCustomerApproval = element.sentForCustomerApproval ? element.sentForCustomerApproval : false;
        single.customerReply = element.customerReply;
        single.sSMOperationId = element.ssmOperationId;
        single.dmsJobLineNo = element.dmsJobLineNo;
        single.isHidePrice = element.isHidePrice;
        single.billToCustomer = element.billToCustomer;
        single.billToCustomerName = element.billToCustomerName;
        single.SSTOperationId = element.sstOperationId;
        single.SSTOperationCode = element.sstOperationCode;
        single.isRentalCarDemand = element.isRentalCarDemand;
        single.isMpoDemand =  element.isMpoDemand;
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  MapToViewNeedAttentionModel(isUpdateAppointment: boolean, isDelete: boolean): any {
    const model: any = {
      Id: this.editAppointmentService.appointmentDetails.id,
      UserId: '',
      IsNeedAttention : this.contactDetails.needAttention ? 2 : this.contactDetails.needAttention,
    };
    model.ModuleId = Enums.ModuleNames.Appointment;
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features?.length > 0 && isUpdateAppointment) {
      model.IntegrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      model.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
    }
    return model;
  }

  getOverallAmountForAppointment()
  {
    //will also work when TAX feature is off as we will get sumPerServiceInclTax but tax was calculated with 0%
    this.overAllAmountInclTAX=0
    this.appointmentDemandList.forEach(element => {
      this.overAllAmountInclTAX+= (element.fixedPrice ? element.fixedPrice : element.sumPerServiceInclTax)
    });
  }
  async GetPartCostAndItemGroupCode(viewModel,isAdditional){
    //To Get latest itemgroup code and cost price to calculate item price 
    let modelPartPrice : any = {}
    let partPriceArray : PartNumberModel[] = [];
    viewModel.AppointmentJobDetailsList.filter(x=>x.isAdditionalWork == isAdditional).forEach(async (obj) => {
      if (obj.CostType == "Material") {
        let part : PartNumberModel = {partNumber : obj.PartNumber};
        partPriceArray.push(part);
      }
    });
    modelPartPrice.locationCode = localStorage.getItem("Theme") === 'mg'?this.contactDetails.dealerDmsNo :this.contactDetails.locationCode ,
    modelPartPrice.parts = partPriceArray;
    if(partPriceArray.length > 0){
      await this.partService.GetPartCostPriceDetails(modelPartPrice).then(response => {
        viewModel.AppointmentJobDetailsList.filter(x=>x.isAdditionalWork == isAdditional).forEach(async (obj) => {
          if (obj.CostType == "Material") {
            // If Incadea/the Parts service has no matching entry for this part number (deleted part,
            // not mapped for this dealer/location, etc.), leave this row's existing price/cost as-is
            // instead of throwing - a single unresolved part must not abort the whole save.
            const incadeaPart = response?.find(f=>f.partNumber == obj.PartNumber);
            if (!incadeaPart) {
              return;
            }
            //if bill to customer changed then get latest unit price
            if(isAdditional){
              let dataCustomer: any = this.appointmentJobDetailToUpdate.filter(x => x.isAdditionalWork && x.id == obj.Id && x.salesPart == obj.PartNumber && x.billToCustomer == obj.billToCustomer )
              if (dataCustomer?.length == 0) {
                obj.unitPrice = incadeaPart.unitPrice;
              }
            }else{
              let dataCustomer: any = this.appointmentJobDetailToUpdate.filter(x => !x.isAdditionalWork && x.id == obj.Id && x.salesPart == obj.PartNumber && x.billToCustomer == obj.billToCustomer )
              //let dataCustomer: any = this.editAppointmentService.appointmentJobDetailsList.filter(x => x.salesPart == obj.PartNumber && x.demandNo == obj.DemandNo && x.billToCustomer == obj.billToCustomer )
              if (dataCustomer?.length == 0) {
                obj.unitPrice = incadeaPart.unitPrice;
              }
            }
            obj.lastDirectCost = incadeaPart.lastDirectCost;
            obj.listPriceLCY = incadeaPart.listPriceLCY;
            obj.costPrice = incadeaPart.unitCost;
            obj.itemGroupCode = incadeaPart.itemGroupCode;
          }
        });
      }).catch(e => {
        // The Parts service call itself failed (network/timeout/5xx). Previously this propagated
        // uncaught, aborting SaveAppointmentData() before UpdateAppointment ever ran - silently
        // failing the save and, since isSaving is only reset inside UpdateAppointment's callback,
        // locking out further saves until the page was reloaded. Log and proceed with existing
        // prices instead; the save itself must not depend on this refresh succeeding.
        console.warn('GetPartCostAndItemGroupCode: failed to refresh part pricing from Incadea; existing prices left unchanged.', e);
      });
    }
    return viewModel;
  }

  async RefreshImportedPartPricesFromIncadea(jobDetailsList: Array<AppointmentJobDetailList>, demandList: Array<AppointmentDemandList>): Promise<boolean> {
    // Parts imported via "SSM Import order" are priced from SSM's own quote at import time (see MapSSMResponse
    // on the backend). This re-prices only those Material lines from Incadea, via the same endpoint already used
    // for manually-added parts, scoped to demands SSM created (ssmOperationId set) so parts the user added by
    // hand on the same work order are left untouched.
    const ssmDemandNos = new Set(
      (demandList || []).filter(d => !this.empty(d.ssmOperationId)).map(d => d.demandNo)
    );
    const ssmPartRows = (jobDetailsList || []).filter(x => x.costType === "Material" && ssmDemandNos.has(x.demandNo));
    if (ssmPartRows.length === 0) {
      return false;
    }
    const partPriceArray: PartNumberModel[] = [];
    ssmPartRows.forEach(obj => {
      if (!partPriceArray.find(p => p.partNumber === obj.salesPart)) {
        partPriceArray.push({ partNumber: obj.salesPart });
      }
    });
    const modelPartPrice: any = {
      locationCode: localStorage.getItem("Theme") === 'mg' ? this.contactDetails.dealerDmsNo : this.contactDetails.locationCode,
      parts: partPriceArray
    };
    try {
      const response = await this.partService.GetPartCostPriceDetails(modelPartPrice);
      if (!response || response.length === 0) {
        return false;
      }
      let anyUpdated = false;
      ssmPartRows.forEach(obj => {
        const incadeaPart = response.find(f => f.partNumber === obj.salesPart);
        if (incadeaPart) {
          obj.unitPrice = incadeaPart.unitPrice;
          obj.costPrice = incadeaPart.unitCost;
          obj.itemGroupCode = incadeaPart.itemGroupCode;
          obj.lastDirectCost = incadeaPart.lastDirectCost;
          obj.listPriceLCY = incadeaPart.listPriceLCY;
          anyUpdated = true;
        }
      });
      return anyUpdated;
    } catch (e) {
      // Incadea lookup failed - leave SSM's price in place rather than blocking/alarming the user;
      // the appointment is already saved successfully at this point.
      return false;
    }
  }
}
